module.exports = __webpack_public_path__ + "img/om.f31f5c7b.svg";